import { createContext } from "react";

import { TToken, TUser } from "@/types";

export interface IAuthContext {
	token: TToken | null;
	user: TUser | null;
	isAuthenticated: boolean;
	// rememberMe is not passed any more: it only sets the lifetime of the
	// refresh cookie, which the API decides from the login payload.
	login: (token: TToken, user: TUser) => void;
	logout: () => void;
	updateUser: (user: TUser) => void;
	hasRole: (roles: string[], all?: boolean) => boolean;
}

export const AuthContext = createContext<IAuthContext | null>(null);
